<div class="container">
    <h1 class="principal-title">Megatendencias</h1>
    <div class="principal-summary">Se ha identificado las megatendencias como grandes fuerzas de cambio de escala
        global, que poseen el potencial de afectar el desarrollo de las regiones inclusive más allá del 2030.
        <br>
        Está vinculada al presente y, al ser medible, ofrece indicios acerca de lo que va a ocurrir en el
        futuro. Asimismo, debido a su inherente interrelación con otras megatendencias, tiene implicancias
        transversales sobre diversos actores; ya sean gobiernos, individuos y sus patrones de consumo, o
        corporaciones y sus estrategias.
    </div>
    <app-carousel [idEventTypeForSlider]="idEvenType"></app-carousel>
    <div class="container-button">
        <a class="btn-foi" *ngIf="t1 && t1.urllistado" href="{{URL}}{{t1.urllistado}}" target="_blank">
            <i class="fa fa-file-pdf-o icon-pdf"></i>Listado de megatendencias
        </a>
    </div>

    <div class="normal-text"> A continuación, seleccione alguna megatendencia para obtener mayor información.
    </div>
    <br>

    <br>
    <div class="row mb-5">
        <div class="col-12 col-sm-6" id="mapaMega">
            <div class="info" *ngIf="!sT3">Seleccione una megatendencia</div>
            <div id="megas-draw"></div>
        </div>
        <div class="col-sm-6 row-mega">
            <ng-container *ngIf="sT3">
                <div class="body-ev m-border p-3">
                    <h2 class="title-mega">{{ sT3.longtitle }}</h2>
                    <div>
                        <ng-container *ngIf="sT3.img != null">
                            <ng-container *ngIf="isUploadDir">
                                <img class="img-fluid img-mega" src="{{URL}}{{sT3.img}}" alt="{{sT3.shorttitle}}">
                            </ng-container>
                            <ng-container *ngIf="!isUploadDir">
                                <img class="img-fluid img-mega" src="{{sT3.img}}" alt="{{sT3.shorttitle}}">
                            </ng-container>
                        </ng-container>
                    </div>
                    <div class="summ-mega">{{ sT3.summary }}</div>
                    <br>
                    <a class="view-more" routerLink="../ficha/{{sT3.code}}">Leer más
                        <i class="icon-trend fa fa-chevron-right"></i>
                    </a>
                </div>
            </ng-container>

        </div>
        <br>
    </div>

    <div class="text-Blue">
        * Revisar documento metodológico sobre megatendencias
        <a *ngIf="t1 && t1.urlmetodologico" href="{{URL}}{{t1.urlmetodologico}}" target="_blank">aquí</a>
    </div>
</div>